import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_BASE_URL,
    withCredentials: true,
});

instance.interceptors.request.use(function (config) {
    config.headers['Cache-Control'] = 'no-cache';
    return config;
}, function (error) {
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response && error.response.status === 401) {
        // Avoid infinite reload loop: don't redirect if already on the login page
        if (window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
    }
    return Promise.reject(error);
});

export default instance;
